"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_GENERATION_CAP_MAX = void 0;
/** The largest daily generation cap the settings form accepts — above this, call it uncapped. */
exports.MEDIA_GENERATION_CAP_MAX = 1000;
//# sourceMappingURL=tenant.js.map